
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.3424 1.04394V7.60061L7.38863 0.650139C11.134 -0.676072 14.3424 1.04394 14.3424 1.04394ZM14.9499 1.31467V11.4579L19.8118 7.2091C18.7429 3.03355 14.9499 1.31467 14.9499 1.31467ZM12.9094 14.4062L19.9113 7.82153C19.9113 7.82153 21.1503 9.83576 19.3027 14.4062H12.9094ZM18.7909 15.241H9.33405L13.5632 19.6129C17.6493 18.3354 18.7909 15.241 18.7909 15.241ZM6.247 13.1522V19.3165C6.247 19.3165 8.7031 20.8893 12.9094 19.8333L6.247 13.1522ZM5.56624 9.17295L0.775994 13.471C2.66736 17.9313 5.55151 18.9421 5.56618 18.9473L5.56624 18.9473V9.17295ZM0.654601 12.7835C0.654601 12.7835 -0.441161 9.24791 1.09144 6.17709H7.68002L0.654601 12.7835ZM6.65981 0.871084C2.89146 2.34553 1.50539 5.48795 1.50539 5.48795H11.1569L6.65981 0.871084Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Moment',
    }) as DefineComponent
    </script>
    